import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { Handle, Range } from 'rc-slider';

export const StyledRangeSlider = styled(Range)`
  &&& {
    position: relative;
    height: ${pxToRem(14)};
    padding: ${pxToRem(5)} 0;
    margin-top: ${pxToRem(20)};
    border-radius: ${pxToRem(6)};
    touch-action: none;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    .rc-slider-track {
      position: absolute;
      left: 0;
      height: ${pxToRem(4)};
      border-radius: ${pxToRem(6)};
      background-color: #c3c3c5;
    }
  }
`;

export const StyledRangeSliderHandle = styled(Handle)<{ $isActive: boolean }>`
  &&&&&&& {
    box-shadow: 0 0 ${pxToRem(4)} #000;
    transition: border-color 0.2s;
    outline: none;
    &.rc-slider-handle {
      position: absolute;
      margin-left: -${pxToRem(7)};
      margin-top: -${pxToRem(5)};
      width: ${pxToRem(14)};
      height: ${pxToRem(14)};
      cursor: grab;
      border-radius: 50%;
      border: ${pxToRem(2)} solid #000;
      touch-action: pan-x;
    }
    &[data-min='true'],
    &[data-max='true'] {
      box-shadow: none;
      pointer-events: none;
      .popup {
        display: none;
      }
    }
    &:hover {
      border-color: ${({ $isActive }) => ($isActive ? '#111' : '#c3c3c5')};
    }
    .cssHandleWrapper {
      position: relative;
      height: ${pxToRem(20)};
      width: ${pxToRem(20)};
      margin: -${pxToRem(5)} 0 0 -${pxToRem(5)};
    }
    .cssPopup {
      position: absolute;
      height: ${pxToRem(20)};
      width: ${pxToRem(80)};
      bottom: ${pxToRem(20)};
      text-align: center;
      margin-left: -${pxToRem(30)};
      opacity: 0;
      outline: none;
      .cssHandleWrapper:hover > & {
        opacity: 1;
      }
    }
  }
`;

export const NumberInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 0;
  margin-top: ${pxToRem(15)};
`;

export const AddButton = styled.div`
  position: relative;
  line-height: 1;
  margin: 0;
  padding: 0;
  width: 100%;
  height: ${pxToRem(10)};
  opacity: 0.1;
  transition: opacity 0.2s calc(0.2s / 2);
  &:hover {
    opacity: 1;
  }
  .cssAddLabel {
    position: absolute;
    left: -${pxToRem(18)};
    top: -${pxToRem(2)};
  }
  .cssAddLine {
    background: #d6d6d6;
    position: absolute;
    top: ${pxToRem(4)};
    height: ${pxToRem(2)};
    width: calc(100% - ${pxToRem(100)});
  }
`;
